// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 594) return "css/594.universalHub.css?v=bddcf15131751495ddac";
	if (chunkId === 636) return "css/636.universalHub.css?v=6da78415968d4fbd0865";
	if (chunkId === 805) return "css/805.universalHub.css?v=8dd8eee7b6900bd01950";
	if (chunkId === 476) return "css/476.universalHub.css?v=1dd86c6b36424288efd6";
	// return url for filenames based on template
	return undefined;
};